import React from "react";

import constants from "../../../constants";
import { ACCEPT_APPOINTMENT } from "../../../constants";

import Modal from "../../../components/uiElements/popupModal/modal";
import Button from "../../../components/formElements/button/Button";

const AppointmentModal = props => {
  const acceptStyles = {
    content: {
      minWidth: "552px",
      maxWidth: "552px",
      minHeight: "400px",
      maxHeight: "400px",
    },
  };

  return (
    <Modal {...props} styles={acceptStyles} title={"Appointment"}>
      <div className="p-5">
        <button
          onClick={props.closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="text-center mx-auto">
          <img src={ACCEPT_APPOINTMENT} alt="success-calendar" />
          <p className="mt-4 mb-0 appointment-accept__text">{props?.message}</p>
          <div className="content-center mt-4">
            <Button
              label="Accept"
              className="mr-2"
              onClick={() =>
                props.onUpdateAppointment(
                  constants.APPOINTMENT_STATUS.accepted,
                  () => props.closeModal()
                )
              }
            />
            <Button
              type="outline"
              label="Reschedule"
              className="mr-2"
              onClick={() =>
                props.onUpdateAppointment(
                  constants.APPOINTMENT_STATUS.rescheduleRequest,
                  () => props.closeModal()
                )
              }
            />
            <Button
              type="outline"
              label="Deny"
              className="mr-2"
              onClick={() =>
                props.onUpdateAppointment(
                  constants.APPOINTMENT_STATUS.denied,
                  () => props.closeModal()
                )
              }
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppointmentModal;
